import { useLocation } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';
import { Box, Button, Drawer, IconButton } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { HashLink } from 'react-router-hash-link';
import PerfectScrollbar from 'react-perfect-scrollbar';

import { useDispatch, useSelector } from 'store';
import { openDrawer } from 'store/slices/menu';

import DrawerItem from '../DrawerItem';

const container = typeof window !== 'undefined' ? () => window.document.body : undefined;

const MobileViewDrawer = () => {
    const theme = useTheme();
    const location = useLocation();
    const dispatch = useDispatch();
    const { drawerOpen } = useSelector((state) => state.menu);

    const handleToggleDrawer = () => {
        if (typeof document !== 'undefined' && document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }
        dispatch(openDrawer(!drawerOpen));
    };

    const getContactUsBtnColor = () => {
        const homePage = ['/'];
        const mediaServiceRelatedPage = [
            '/media-service',
            '/data-driven-programmatic',
            '/premium-placement',
            '/campaign-management-service',
            '/china-media-solutions',
            '/ai-creation'
        ];
        const dataServiceRelatedPage = ['/data-service', '/external-data', '/insight-report', '/etl-project'];

        let background = 'unset';
        const color = '#FFFFFF';

        if (homePage.includes(location.pathname) || location.pathname.match(/^\/blog(\/.*)?$/)) {
            background = 'linear-gradient(89.51deg, #E15C12 0.42%, #FCB336 101.32%)';
        } else if (mediaServiceRelatedPage.includes(location.pathname)) {
            background = 'linear-gradient(90deg, #54A390 0%, #4987D8 100%)';
        } else if (dataServiceRelatedPage.includes(location.pathname)) {
            background = 'linear-gradient(148.07deg, #AD5BD7 3.97%, #7B6CF9 100%)';
        } else {
            background = 'linear-gradient(89.51deg, #E15C12 0.42%, #FCB336 101.32%)';
        }

        return {
            background,
            color,
            '&:hover': {
                background,
                color
            }
        };
    };

    return (
        <Box component="nav" sx={{ flexShrink: { lg: 0 }, width: 'auto' }} aria-label="mailbox folders">
            <Drawer
                container={container}
                variant="temporary"
                anchor="right"
                open={drawerOpen}
                onClose={handleToggleDrawer}
                sx={{
                    position: 'relative',
                    '& .MuiDrawer-paper': {
                        width: '100%',
                        color: theme.palette.text.primary,
                        bgcolor: '#FFFFFF',
                        borderRight: 'none',
                        overflowY: 'unset'
                    }
                }}
                ModalProps={{
                    keepMounted: true,
                    disableAutoFocus: true,
                    disableEnforceFocus: true,
                    disableRestoreFocus: true
                }}
                PaperProps={{
                    tabIndex: undefined
                }}
                color="inherit"
            >
                <Box sx={{ width: '100%', height: '80px', position: 'relative' }}>
                    <IconButton
                        sx={{ position: 'absolute', top: '50%', right: '20px', transform: 'translateY(-50%)' }}
                        onClick={handleToggleDrawer}
                    >
                        <CloseOutlined sx={{ color: '#2D2D2D' }} />
                    </IconButton>
                </Box>
                <PerfectScrollbar style={{ height: '100%', maxHeight: 'calc(100vh - 100px)', overflowX: 'hidden' }}>
                    <Box
                        sx={{
                            width: '100%',
                            height: '100%',
                            padding: '0 44px',
                            display: 'flex',
                            flexFlow: 'column',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexFlow: 'column', gap: '24px' }}>
                            <DrawerItem
                                name="Media Service"
                                url="/media-service"
                                haveSubItem
                                subItemDetail={[
                                    { name: 'Data-driven Programmatic', url: '/data-driven-programmatic' },
                                    { name: 'Premium Placement', url: '/premium-placement' },
                                    { name: 'Campaign Management Service', url: '/campaign-management-service' },
                                    { name: 'China Media Solutions', url: '/china-media-solutions' },
                                    { name: 'AI Creation', url: '/ai-creation' }
                                ]}
                                handleDrawerClose={handleToggleDrawer}
                            />
                            <DrawerItem
                                name="Data Service"
                                haveSubItem
                                subItemDetail={[
                                    { name: 'External Data', url: '/external-data' },
                                    { name: 'Insight Report', url: '/insight-report' },
                                    { name: 'ETL Project', url: '/etl-project' }
                                ]}
                                url="/data-service"
                                handleDrawerClose={handleToggleDrawer}
                            />
                            <DrawerItem
                                name="AD Gallery"
                                url="https://showcase.hot-mob.com/"
                                isExternal
                                handleDrawerClose={handleToggleDrawer}
                            />
                            <DrawerItem name="Blog" url="/blog" handleDrawerClose={handleToggleDrawer} />
                            <DrawerItem isHashLink name="About Us" url="/#about-us" handleDrawerClose={handleToggleDrawer} />
                        </Box>
                        <Box sx={{ marginTop: '24px' }}>
                            <HashLink smooth to="/#contact-us" style={{ alignSelf: 'center' }}>
                                <Button
                                    variant="contained"
                                    size="large"
                                    sx={{
                                        borderRadius: '100px',
                                        fontWeight: 700,
                                        padding: '10px 14px',
                                        ...getContactUsBtnColor()
                                    }}
                                    onClick={handleToggleDrawer}
                                >
                                    Contact Us
                                </Button>
                            </HashLink>
                        </Box>
                    </Box>
                </PerfectScrollbar>
            </Drawer>
        </Box>
    );
};

export default MobileViewDrawer;
